/* /main mobile carousel: keeps the dot indicators in sync with the swiped panel */
(function () {
    var track = document.querySelector('.front-main');
    var dotBar = document.querySelector('.front-dots');
    var dots = document.querySelectorAll('.front-dot');

    if (!track || !dots.length) {
        return;
    }

    function activate(id) {
        /* Lets the CSS flip the dots to dark on the one light panel. */
        if (dotBar) {
            dotBar.setAttribute('data-panel', id);
        }

        for (var i = 0; i < dots.length; i++) {
            if (dots[i].getAttribute('data-target') === id) {
                dots[i].setAttribute('aria-current', 'true');
            } else {
                dots[i].removeAttribute('aria-current');
            }
        }
    }

    for (var i = 0; i < dots.length; i++) {
        dots[i].addEventListener('click', function (event) {
            var panel = document.getElementById(event.currentTarget.getAttribute('data-target'));

            if (panel) {
                panel.scrollIntoView({behavior: 'smooth', inline: 'start', block: 'nearest'});
            }
        });
    }

    if (!window.IntersectionObserver) {
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
                activate(entries[j].target.id);
            }
        }
    }, {root: track, threshold: 0.6});

    var panels = track.querySelectorAll('.front-column');

    for (var k = 0; k < panels.length; k++) {
        observer.observe(panels[k]);
    }
})();
